__turbopack_context__.v({
  "stripContainer": "StripTextUI-module-scss-module__779j4q__stripContainer",
});
